export const testimonialsData = [
  {
    id: 1,
    name: "Alex Chen",
    role: "CTO at Streamline Inc",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20an%20Asian%20man%20in%20his%2030s%20with%20glasses%2C%20confident%20smile%2C%20modern%20tech%20office%20background%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20professional%20photography%2C%20business%20casual%20attire&width=200&height=200&seq=201&orientation=squarish",
    content: "ForceKeys built our entire SaaS platform in record time. Their expertise in scalable architecture saved us months of development. The team is incredibly responsive and technically sharp.",
    rating: 5,
  },
  {
    id: 2,
    name: "Sarah Williams",
    role: "Lead Developer at GlobalTech",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20woman%20in%20her%20late%2020s%20with%20confident%20expression%2C%20modern%20tech%20environment%20background%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20professional%20photography%2C%20casual%20smart%20attire&width=200&height=200&seq=202&orientation=squarish",
    content: "Translate Cloud API is a game changer. We went from juggling 4 different translation providers to one clean, unified API. The batch processing and OCR features are exactly what our product needed.",
    rating: 5,
  },
  {
    id: 3,
    name: "Marcus Johnson",
    role: "Product Manager at Nexus Labs",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20an%20African%20American%20man%20in%20his%20mid%2030s%20with%20warm%20smile%2C%20modern%20tech%20office%20background%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20professional%20photography%2C%20business%20casual%20attire&width=200&height=200&seq=203&orientation=squarish",
    content: "We hired ForceKeys to develop our SaaS application and the result exceeded expectations. Clean code, great architecture, and they delivered on time. Their support portal is also top-notch.",
    rating: 5,
  },
];

export const servicesData = [
  {
    id: 1,
    icon: "ri-code-box-line",
    title: "SaaS Application Development",
    description: "End-to-end SaaS development from concept to deployment. We build scalable, secure, and high-performance applications tailored to your business needs.",
  },
  {
    id: 2,
    icon: "ri-cloud-line",
    title: "Cloud Architecture",
    description: "Design and implement cloud-native architectures on AWS, Azure, or GCP. We ensure your infrastructure scales seamlessly with your growth.",
  },
  {
    id: 3,
    icon: "ri-shield-check-line",
    title: "API Development & Integration",
    description: "Build robust REST and GraphQL APIs. We specialize in third-party integrations, webhook systems, and real-time data processing.",
  },
  {
    id: 4,
    icon: "ri-dashboard-line",
    title: "DevOps & CI/CD",
    description: "Automated deployment pipelines, container orchestration, monitoring, and infrastructure as code. Ship faster with confidence.",
  },
  {
    id: 5,
    icon: "ri-smartphone-line",
    title: "Mobile & Web Apps",
    description: "Cross-platform mobile apps and responsive web applications using modern frameworks. One codebase, every device.",
  },
  {
    id: 6,
    icon: "ri-customer-service-2-line",
    title: "Ongoing Support",
    description: "Dedicated support team, maintenance contracts, and a comprehensive support portal at support.saas.forcekeys.com.",
  },
];

export const translateProviders = [
  { id: "google", name: "Google Cloud", icon: "ri-google-fill", color: "bg-blue-500/10 text-blue-500" },
  { id: "azure", name: "Azure Translator", icon: "ri-microsoft-fill", color: "bg-sky-500/10 text-sky-500" },
  { id: "aws", name: "AWS Translate", icon: "ri-amazon-fill", color: "bg-orange-500/10 text-orange-500" },
  { id: "deepl", name: "DeepL", icon: "ri-translate", color: "bg-emerald-500/10 text-emerald-500" },
  { id: "forcekeys", name: "ForceKeys Cloud", icon: "ri-key-2-line", color: "bg-violet-500/10 text-violet-500" },
];

export const translateFeatures = [
  {
    id: 1,
    icon: "ri-file-text-line",
    title: "Document Translation",
    description: "Upload and translate entire documents while preserving formatting. Supports PDF, Word, PowerPoint, and more with layout retention.",
  },
  {
    id: 2,
    icon: "ri-scan-line",
    title: "OCR Processing",
    description: "Extract text from images and scanned documents before translating. Our OCR engine handles complex layouts and multiple languages.",
  },
  {
    id: 3,
    icon: "ri-stack-line",
    title: "Batch Processing",
    description: "Translate thousands of files or text segments in a single batch job. Asynchronous processing with real-time status updates via webhooks.",
  },
  {
    id: 4,
    icon: "ri-plug-line",
    title: "Unified API",
    description: "One API endpoint to access Google, Azure, AWS, DeepL and ForceKeys Cloud. Switch providers instantly without changing your integration code.",
  },
];